import { ArrowRight } from 'lucide-react'
import { cn } from '../utils/cn'
import Container from './container'

export default function NossosServicos({
  servicos,
  description,
  bannerImage,
  bgColor,
}) {
  return (
    <div className="bg-[url(../assets/banner-proposito.png)] bg-cover bg-no-repeat py-12 md:py-16 lg:py-32 text-white">
      <Container className="flex flex-col gap-20 lg:justify-between lg:flex-row lg:items-center lg:gap-2">
        <section className="lg:max-w-[466px]">
          <div className="space-y-5 text-center lg:text-left">
            <h2 className="font-inter-regular text-3xl md:text-5xl">
              Nossos{' '}
              <span
                className={`bg-gradient-to-r ${bgColor} text-transparent bg-clip-text`}
              >
                serviços
              </span>
            </h2>
            <p className="font-inter-regular text-[#F9F2F2] text-base md:text-2xl px-2 lg:px-0">
              {description}
            </p>
          </div>
          <div className="space-y-8 mt-12 lg:mt-8 mx-2 md:mx-0">
            {servicos.map((servico, index) => (
              <>
                <div className="flex items-center gap-6" key={servico.id}>
                  <div className="ml-2 absolute size-7 md:size-12 bg-white rounded-full blur-sm" />
                  <div className="relative flex items-center justify-center p-2.5 md:p-4 aspect-square rounded-full bg-[#0A0238] overflow-hidden">
                    <img
                      src={servico.image}
                      alt=""
                      className="relative z-10 size-[22px] md:size-8 aspect-square"
                    />
                  </div>
                  <div className="space-y-0">
                    <h3 className="font-inter-bold text-lg md:text-2xl">
                      {servico.title}
                    </h3>
                    <a
                      href={servico.link || '/servicos'}
                      className={cn(
                        'flex items-center text-[13px] md:text-base gap-2 font-inter-regular hover:text-[#008CFF]',
                      )}
                    >
                      <span>Conhecer o serviço</span>
                      <ArrowRight className="w-4 md:w-auto" />
                    </a>
                  </div>
                </div>

                <hr
                  key={index}
                  className={cn(
                    'lg:hidden border-[rgba(255,255,255,0.4)]',
                    index === servicos.length - 1 && 'hidden',
                  )}
                />
              </>
            ))}
          </div>
        </section>
        <section className="w-full hidden lg:block">
          <img
            src={bannerImage}
            alt="Nossos serviços"
            className="w-full block"
          />
        </section>
      </Container>
    </div>
  )
}
